
import '../../css_styles/button_styles.css'
import { useState} from 'react';
import { Link } from 'react-router-dom';

function NavigationButton(props) {
      const [Styles, setStyles] = useState("default");
      let button_style = 'nav_button default'; //"nav_button default";
      function handleMouseEnter() {
            setStyles("hover");
            }
      function handleMouseLeave() {
            setStyles("default");
            }

      if ( Styles==="default") {
                button_style = 'nav_button default'; //"nav_button default";
            }
      if ( Styles==="hover") {
                button_style = 'nav_button hover'; //"nav_button hover";
            }

       if (props.is_selected)
         {
            button_style= 'nav_button selected'; //"nav_button selected";
         }


    return (
        <Link style={{textDecoration: 'none'}} id={props.id} to={props.href} className={button_style} onClick={props.onUpdateSelection} onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter}>
           {props.title}
        </Link>
    );


}


export default NavigationButton;